<template>
  <a-card :bordered="false">
    <a-form-model ref="form" :model="form.data" :rules ="rules">
      <a-form-model-item label="原密码" prop="oldPassword">
        <a-input-password
          size="large"
          v-model="form.data.oldPassword"
          :disabled="form.disabled"
          show-passoword>
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item label="新密码" prop="newPassword1">
        <a-input-password
          size="large"
          v-model="form.data.newPassword1"
          :disabled="form.disabled"
          show-password>
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
        </a-input-password>
      </a-form-model-item>
       <a-form-model-item label="确认新密码" prop="newPassword2">
        <a-input-password
          size="large"
          v-model="form.data.newPassword2"
          :disabled="form.disabled"
          show-password>
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item>
        <a-button
          @click="confirmPassword"
          type="primary">
          更新
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import { _updateUserPassword } from '@/api/sysUserApi';

async function confirmPassword() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      if (this.form.data.newPassword1 !== this.form.data.newPassword2) {
        this.$message.error('请确保两次密码输入一致后，重新尝试！');
        this.form.disabled = false;
        return;
      };
      this.$confirm({
        title: '是否要修改密码？',
        content: '',
        onOk: async () => {
          this.form.disabled = true;
          const result = await _updateUserPassword({
            newPassword: this.form.data.newPassword1,
            oldPassword: this.form.data.oldPassword,
          });
          if (result && result) {
            this.form.disabled = false;
            this.$message.success('修改成功');
            this.$router.push('/');
            return;
          }
          this.$message.error('原密码输入错误');
          this.form.disabled = false;
        },
      });
    }
  });
}
export default {
  name: 'Setting',
  data() {
    return {
      autoLogin: false,
      form: {
        disabled: false,
        data: {
          oldPassword: '',
          newPassword1: '',
          newPassword2: '',
        },
      },
      rules: {
        oldPassword: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur',
        }],
        newPassword1: [

          {
            required: true, message: 'Please input the passowrd', trigger: 'blur',
          },
          { min: 8, message: '字符长度至少大于8', trigger: 'blur' },
        ],

        newPassword2: [

          {
            required: true, message: 'Please input the passowrd', trigger: 'blur',
          },
          { min: 8, message: '字符长度至少大于8', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    confirmPassword,
  },
  mounted() {
  },
};
</script>

<style>

.canvas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
}
</style>
